// TODO: https://lessonup.atlassian.net/browse/UP-111 - Create a system with design
export const transition = {
  duration: {
    slow: '450ms',
    medium: '300ms',
    fast: '150ms',
  },
};
